import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { workspaceQueryOptions } from '@/features/workspaces';
import type { TaskView } from '@/lib/api/generated/model';
import { deletionImpact, type DeletionImpact } from '../taskDeletion';

/**
 * What deleting `task` would take with it, read from the workspace aggregate the
 * board already holds. The query is the board's own, so this adds no request
 * while the board is up; with no workspace it stays idle.
 */
export function useDeletionImpact(
  workspaceId: string | undefined,
  task: TaskView | undefined,
): DeletionImpact | undefined {
  const { data } = useQuery({
    ...workspaceQueryOptions(workspaceId ?? ''),
    enabled: workspaceId !== undefined && workspaceId !== '',
  });
  const workspaceTasks = data?.tasks;
  return useMemo(
    () => (task ? deletionImpact(task, workspaceTasks ?? []) : undefined),
    [task, workspaceTasks],
  );
}
